import React from "react";

import { InputContainer, Radio } from "./styles";

interface IProps {
  options: Array<string>;
  SelectedOption: string;
  HandleOptionChange: (e) => void;
}

export const Opcoes: React.FC<IProps> = ({
  options,
  SelectedOption,
  HandleOptionChange
}) => {

  return (
    <span>
      <InputContainer>
        <Radio
          type={"radio"}
          name={"inlineRadioOptions"}
          id={"inlineRadio1"}
          value={options[0]}
          checked={SelectedOption === options[0]}
          onChange={HandleOptionChange}
        />

        <label
          className={"form-check-label"}
          htmlFor={"inlineRadio1"}
        >
          {"Data"}
        </label>
      </InputContainer>

      <InputContainer>
        <Radio
          type={"radio"}
          name={"inlineRadioOptions"}
          id={"inlineRadio2"}
          value={options[1]}
          checked={SelectedOption === options[1]}
          onChange={HandleOptionChange}
        />

        <label
          className={"form-check-label"}
          htmlFor={"inlineRadio2"}
        >
          {"Nome"}
        </label>
      </InputContainer>
    </span>
  );
}
